import styled from 'styled-components';

export const StyledFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding: var(--space-4);
  background-color: var(--c-surface);
  border: var(--border);
  border-radius: var(--radius-lg);

  .filters__select {
    flex: 1 1 140px;
    padding: var(--space-2) var(--space-3);
    background-color: var(--c-surface-2);
    color: var(--c-text);
    border: var(--border);
    border-radius: var(--radius-md);
    font-size: var(--fs-sm);
    cursor: pointer;
    transition: border-color 0.2s ease;
  }

  .filters__select:hover {
    border-color: var(--c-border-strong);
  }

  .filters__select:focus-visible {
    border-color: var(--c-accent);
  }

  .filters__option {
    background-color: var(--c-surface-2);
    color: var(--c-text);
  }

  .filters__inputs-container {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: var(--space-3);
  }

  .filters__label {
    display: flex;
    width: max-content;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3);
    background-color: var(--c-surface-2);
    border: var(--border);
    border-radius: var(--radius-full);
    font-size: var(--fs-sm);
    color: var(--c-text-muted);
    cursor: pointer;
    transition:
      border-color 0.2s ease,
      color 0.2s ease,
      background-color 0.2s ease;
  }

  .filters__label:hover {
    color: var(--c-text);
    border-color: var(--c-border-strong);
  }

  .filters__label:has(.filters__checkbox:checked) {
    color: var(--c-text);
    border-color: var(--c-accent);
    background-color: var(--c-accent-subtle);
  }

  .filters__checkbox {
    display: none;
  }

  @media (min-width: 1200px) {
    position: sticky;
    top: 88px;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;

    .filters__select {
      flex: none;
      width: 100%;
    }
  }
`;
